const dovizDataConverter = ({ selectedNews, newsList }) => {
  return {
    slideItems: selectedNews.map((newsId) => {
      const news = newsList.find((news) => news.id === newsId);
      return {
        title: news.title ?? "",
        category: (news.category ?? "").slice(0, 25), // max 25
        voiceText: (news.voiceText ?? ""),
        imageUrl: (news.image ?? ""),
      };
    }),
  };
};

export { dovizDataConverter };
